var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"investor-preview-component"},[_c('div',{staticClass:"title"},[_vm._v("Investor preview")]),_c('div',{staticClass:"preview-container"},[_c('InvestorInfo'),_c('Transactions'),_c('Connections'),_c('Portfolio')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }